import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AllReportsErpComponent } from './all-reports-erp/all-reports-erp.component';


const routes : Routes = [
    {path: '', component: AllReportsErpComponent},
    
]

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})

export class ReportsRoutingErpModule {}